// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyAiBwIqYmWs9iJy1NldrdkNNPNMKUT3x6k',
    authDomain: 'travel-esolutions-notifi-a375d.firebaseapp.com',
    projectId: 'travel-esolutions-notifi-a375d',
    storageBucket: 'travel-esolutions-notifi-a375d.appspot.com',
    messagingSenderId: '185283980629',
    appId: '1:185283980629:web:95eaceedda3043677993dc',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
